import { useAppDispatch, useEffectDebounce } from 'hooks';
import { actionChatReadConversation } from '../store';
import { useChatConversation } from './use-chat-conversation';

export const useChatRead = () => {
  const dispatch = useAppDispatch();
  const { isInit, conversation, isLoading } = useChatConversation();

  useEffectDebounce(
    () => {
      if (isInit && !isLoading && conversation && conversation.notRead) {
        dispatch(actionChatReadConversation({ conversationID: conversation.conversationID }));
      }
    },
    2000,
    [isInit, dispatch, conversation, isLoading],
  );
};
